/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.templates.create.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.factory.notice'
])

.controller('EntitiesTemplatesCreateController', ['$scope', '$state', '$timeout', '$interval', 'ApiService', 'HelpersService', 'NoticeFactory', function($scope, $state, $timeout, $interval, ApiService, HelpersService, NoticeFactory) {

    $scope.entitiesTemplatesCreate = {

      editName: '',
      entityType: {},

      mode: 'create',
      isUpdated: false,
      enableNameEdit: false,
      checkForUpdatesTimer: false,

      cache: {},
      saveModel: {},
      model: {
        name: '',
        resourceCategory: '',
        fields: [
          {
            name: '',
            description: '',
            displayType: 'Checkbox',
            displayValues: [],
            values: []
          }
        ]
      },

      labels: {
        qualifier: {
          upper: '',
          lower: ''
        },
        attribute: {
          upper: '',
          lower: ''
        }
      },

      fieldTypes: [
        {
          type: 'Checkbox',
          label: 'Checkboxes'
        },
        {
          type: 'Dropdown',
          label: 'Dropdown'
        }
      ],

      notice: new NoticeFactory(),

      init: function() {

        this.entityType = HelpersService.getEntityName($state.params.type);

        if ($state.params.id) {
          this.mode = 'edit';
        }else{
          $scope.$emit('AppController::updateTitle', {
            title: HelpersService.cap(this.entityType.displayPlural) + ' Types'
          });
        }

        $scope.$emit('Application::contentTitleChange', {
          title: HelpersService.cap(this.entityType.displayPlural) + ' Types',
          buttonRight: {
            label: 'Save Changes',
            permissions: 'ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_CREATE',
            action: function () {
              $scope.entitiesTemplatesCreate.complete();
            }
          },
          buttonLeft: {
            label: 'Cancel',
            action: function () {
              $scope.entitiesTemplatesCreate.cancel();
            }
          }
        });

        $scope.$on('EntitiesListController::CreateType', this.onEntitiesListControllerCreateType);
        $scope.$on('EntitiesListController::SelectType', this.onEntitiesListControllerSelectType);
        $scope.$on('$destroy', function() {
          $interval.cancel($scope.entitiesTemplatesCreate.checkForUpdatesTimer);
        });

        this.checkForUpdates();
        this.getType($state.params.id);
      },

      getType: function(id) {
        if (id) {
          ApiService.resource.detail(id).then(this.success.getType, this.error.getType);
        }
      },

      checkForUpdates: function() {
        this.checkForUpdatesTimer = $interval(function() {
          var self = $scope.entitiesTemplatesCreate,
            current = angular.toJson(self.model);

          if (self.mode === 'edit') {
            self.isUpdated = (current !== angular.toJson(self.cache));
          }else{
            self.isUpdated = (current !== angular.toJson(self.createModel()));
          }
        }, 1000);
      },

      setLabels: function() {
        switch(this.entityType.singular) {
          case 'facility':
            /* falls through */
          case 'equipment':
            this.labels = {
              qualifier: {
                upper: 'Type',
                lower: 'type'
              },
              attribute: {
                upper: 'Attribute',
                lower: 'attribute'
              }
            };
            break;
          case 'personnel':
            this.labels = {
              qualifier: {
                upper: 'Role',
                lower: 'role'
              },
              attribute: {
                upper: 'Skill',
                lower: 'skill'
              }
            };
            break;
        }
      },

      isInputType: function(field, type) {
        return (field.displayType === type);
      },

      addValue: function(field) {
        if (!(field.displayValues instanceof Array)) {
          field.displayValues = [];
        }
        field.displayValues.push({ value: '' });
      },

      removeValue: function(field, index) {
        if (field.displayValues instanceof Array) {
          field.displayValues.splice(index, 1);
        }
      },

      hasFields: function() {
        return (this.model.fields instanceof Array && this.model.fields.length);
      },

      resetModel: function() {
        this.model = this.createModel();
      },

      createModel: function() {
        return {
          name: '',
          description: '',
          resourceCategory: HelpersService.cap(this.entityType.plural)
        };
      },
      createField: function() {
        return {
          name: this.model.name,
          displayType: 'Checkbox',
          displayValues: [],
          values: []
        };
      },

      addField: function() {
        this.model.fields.push(this.createField());
      },

      removeField: function(index) {
        this.model.fields.splice(index, 1);
      },

      checkFieldValues: function(field) {
        if (field.displayType) {
          if (!field.displayValues || field.displayValues.length === 0) {
            this.addValue(field);
          }
        }
      },

      clearFieldValues: function(field) {
        field.displayValues = [];
      },

      saveNameEdit: function() {
        this.model.name = angular.copy(this.editName);
      },

      openNameEdit: function() {
        this.editName = angular.copy(this.model.name);
        this.enableNameEdit = true;
      },

      closeNameEdit: function() {
        this.enableNameEdit = false;
      },

      closeSaveNameEdit: function() {
        this.saveNameEdit();
        this.closeNameEdit();
      },

      toggleNameEdit: function() {
        this.enableNameEdit = !this.enableNameEdit;
      },

      prepare: function() {
        var i, ii,
            j, jj,
            r = angular.copy(this.model);

        r.resourceCategory = HelpersService.cap(this.entityType.plural);

        if (r.fields instanceof Array) {

          for (i = 0, ii = r.fields.length; i < ii; i++) {

            r.fields[i].values = [];

            if (!r.fields[i].name || r.fields[i].name.length === 0) {
              r.fields[i].name = r.name;
            }

            if (r.fields[i].displayValues instanceof Array) {

              for (j = 0, jj = r.fields[i].displayValues.length; j < jj; j++) {
                r.fields[i].values.push(r.fields[i].displayValues[j].value);
              }

              r.fields[i].displayValues = null;
              delete r.fields[i].displayValues;

            }

          }

        }

        return r;
      },

      process: function() {
        var i, ii,
            j, jj;

        for (i = 0, ii = this.model.fields.length; i < ii; i++) {

          this.model.fields[i].displayValues = [];

          if (this.model.fields[i].values instanceof Array) {

            for (j = 0, jj = this.model.fields[i].values.length; j < jj; j++) {
              this.model.fields[i].displayValues.push({ value: this.model.fields[i].values[j] });
            }

          }

        }

      },

      complete: function() {
        if (this.mode === 'edit') {
          this.update();
        }else {
          this.create();
        }
      },

      create: function() {
        this.saveModel = angular.copy(this.model);
        ApiService.resource.create(this.prepare()).then(this.success.create, this.error.create);
      },

      update: function() {
        this.saveModel = angular.copy(this.model);
        ApiService.resource.update(this.prepare()).then(this.success.update, this.error.update);
      },

      cancel: function() {

        if (this.mode === 'edit') {
          this.model = angular.copy(this.cache);
        }else{
          this.resetModel();
        }

        window.history.go(-1);

        $scope.$emit('EntitiesTemplatesCreate::Cancel');

      },

      success: {
        init: function(response) {},

        getType: function(response) {
          var self = $scope.entitiesTemplatesCreate;

          self.model = angular.copy(response.data.resourceType);
          self.process();


          $scope.$emit('AppController::updateTitle', {
            title: self.model.name
          });

          $scope.$emit('Application::contentTitleChange', {
            title: self.model.name,
            buttonRight: {
              label: 'Save Changes',
              permissions: 'ENTITY_TEMPLATE_' + self.entityType.singular.toUpperCase() + '_CREATE',
              action: function () {
                self.complete();
              }
            },
            buttonLeft: {
              label: 'Cancel',
              action: function () {
                self.cancel();
              }
            }
          });

          self.cache = angular.copy(self.model);

        },

        create: function(response) {

          var self = $scope.entitiesTemplatesCreate;

          self.mode = 'edit';

          self.model.id = response.data.payload.id;

          self.notice.showSuccessMessages([{
            message: 'Successfully created'
          }]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
            $timeout(function() {
              $state.go('application.entities.templates', { type: $state.params.type });
            }, 300);
          }, 3000);

          $scope.$emit('EntitiesTemplatesCreate::Create', { template: angular.copy(response.data.payload) });

        },

        update: function(response) {

          var self = $scope.entitiesTemplatesCreate;

          self.notice.showSuccessMessages([{
            message: 'Successfully updated'
          }]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
            $timeout(function() {
              $state.go('application.entities.templates', { type: $state.params.type });
            }, 300);
          }, 3000);

          self.model = angular.copy(self.saveModel);
          self.cache = angular.copy(self.model);
          self.saveModel = {};
          $scope.$emit('EntitiesTemplatesCreate::Update', { template: angular.copy(self.model) });

        }
      },

      error: {
        init: function(response) {},
        getType: function(response) {},
        create: function(response) {
          var self = $scope.entitiesTemplatesCreate;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        update: function(response) {
          var self = $scope.entitiesTemplatesCreate;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      },

      onNameFieldKeydown: function(e) {
        var self = $scope.entitiesTemplatesCreate;

        if (e.keyCode === 13 || e.keyCode === 9) {
          self.saveNameEdit();
          self.closeNameEdit();
        }else if (e.keyCode === 27) {
          self.closeNameEdit();
        }
      },

      onEntitiesListControllerCreateType: function(e, data) {
        var self = $scope.entitiesTemplatesCreate;

        self.mode = 'create';
        self.entityType = data.entityType;
        self.setLabels();
        self.resetModel();
      },

      onEntitiesListControllerSelectType: function(e, data) {
        var self = $scope.entitiesTemplatesCreate;

        self.mode = 'edit';
        self.entityType = data.entityType;
        self.setLabels();
        self.getType(data.typeId);
      }

    };

    $scope.entitiesTemplatesCreate.init();

}]);